import LoggerFactory from '../service/LoggerFactory';
import {LogLevel, SimpleLogger} from "@mosaic/logger-service";

/**
 * LoggerProxy acts as a lightweight proxy that delegates to the real logger
 * instance retrieved from LoggerFactory. This allows consumers to hold a
 * stable reference while LoggerFactory can replace or update implementations.
 */
export class LoggerProxy implements SimpleLogger {
  constructor(private readonly componentName: string) {}

  private get instance() {
    return LoggerFactory.getLogger(this.componentName);
  }

  component() { return this.instance.component(); }

  debug(msg: string, ...args: any[]) { this.instance.debug(msg, ...args); }
  info(msg: string, ...args: any[]) { this.instance.info(msg, ...args); }
  warn(msg: string, ...args: any[]) { this.instance.warn(msg, ...args); }
  error(msg: string, ...args: any[]) { this.instance.error(msg, ...args); }
  setLevel(level: LogLevel): LogLevel { return this.instance.setLevel(level); }
  getLevel() { return this.instance.getLevel(); }
  setThreshold(name: string, newLevel: LogLevel) {
    return this.instance.setThreshold(name, newLevel);
  }
  getThreshold(name: string) {
    return this.instance.getThreshold(name);
  }
}
